document.addEventListener("DOMContentLoaded", function () {
    // 
    // accordion
    // 

    const accordionHeaders = document.querySelectorAll('.accordion .accordion-header');

    accordionHeaders.forEach(headers => {
        headers.addEventListener('click', () => {

            let attributesValue = headers.attributes.getNamedItem("aria-expanded").value;

            headers.setAttribute('aria-expanded', attributesValue === "true" ? 'false' : 'true');

            // 
            // 
            const accordionContent = headers.parentElement.querySelector('.accordion-content');
            const isOpen = accordionContent.classList.contains('show');

            // Toggle the clicked one
            if (!isOpen) {
                accordionContent.classList.add('show');
                accordionContent.style.maxHeight = `${accordionContent.scrollHeight + 5}px`;
            } else {
                accordionContent.classList.remove('show');
                accordionContent.style.maxHeight = null;
            }
        });
    });
});